var React = require('react');

function Weightbar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.8602 6.23408h-1.3438v-4.5859c0-.726403-.5907-1.315172-1.3152-1.315172h-3.0031c-.7264 0-1.3152.590681-1.3152 1.315172v2.7049H6.97921v-2.7049c0-.726403-.59068-1.315172-1.31517-1.315172H2.65902c-.7264 0-1.31517.590681-1.31517 1.315172v4.5859H0v1.52927h1.34385v4.58595c0 .7264.59068 1.3151 1.31517 1.3151h3.00311c.7264 0 1.31517-.5907 1.31517-1.3151v-3.72H5.44803v3.5059H2.87312V1.86228h2.57682v2.7049c0 .7264.59068 1.31517 1.31518 1.31517H18.0951c.7264 0 1.3152-.59068 1.3152-1.31517v-2.7049h2.5768V12.1371h-2.5768V9.94448c0-.72641-.5907-1.31518-1.3152-1.31518H9.10299v1.5293h8.77991v2.1907c0 .7264.5907 1.3151 1.3152 1.3151h3.0031c.7264 0 1.3152-.5907 1.3152-1.3151V7.76335h1.3438V6.23408Z","fill":"currentColor"}));
}

Weightbar.defaultProps = {"width":"25","height":"14","viewBox":"0 0 25 14","fill":"none"};

module.exports = Weightbar;

Weightbar.default = Weightbar;
